export default function blogImageSlider() {

	if ($('.js-blog_big-image-slider').length > 0) {
		// функция для отображение текущего слайда
		var $status = $('.js-blog_big-image-current-slide');
		var $slickElement = $('.js-blog_big-image-slider');

		$slickElement.on('load init reInit beforeChange afterChange', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			if (!slick.$dots) {
				return;
			}

			var i = (currentSlide ? currentSlide : 0) + 1;
			$status.text(i + ' из ' + (slick.$dots[0].children.length));
		});

		// инициализация слайдера с большими картинками
		$('.js-blog_big-image-slider').slick({
			dots: true,
			infinite: false,
			speed: 300,
			arrows: true,
			slidesToShow: 1,
		});
	}
}